
import { Campaign } from "@/hooks/useCampaigns";
import { Loader2 } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface PublishCampaignDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  campaign: Campaign | null;
  isProcessing: boolean;
  onConfirm: () => void;
}

export function PublishCampaignDialog({
  open,
  onOpenChange,
  campaign,
  isProcessing,
  onConfirm
}: PublishCampaignDialogProps) {
  if (!campaign) return null;
  
  const willBeActive = new Date(campaign.start_date) <= new Date();
  
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Publish Campaign</AlertDialogTitle>
          <AlertDialogDescription>
            This will publish the draft campaign and generate {campaign.vouchers_total} voucher codes.
            <br /><br />
            The campaign status will be set to {willBeActive ? "'Active'" : "'Scheduled'"}.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isProcessing}>Cancel</AlertDialogCancel>
          <AlertDialogAction 
            onClick={(e) => {
              e.preventDefault();
              onConfirm();
            }}
            disabled={isProcessing}
            className="flex items-center"
          >
            {isProcessing && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            {isProcessing ? "Publishing..." : "Publish Campaign"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
